// ----------------------------------------------------------------------
// <copyright file="Izenda.Tab.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Tab Component
 * Example :
 * <Tabs>
    <Tab title='Tab 1'>
      <h2>Content 1 here</h2>
    </Tab>
    <Tab title='Tab 2'>
      <h2>Content 2 here</h2>
    </Tab>
  </Tabs>
 */

!(function() {
  var React = require('react');
  var classnames = require('classnames');
  var MenuToolbar = require('./Izenda.MenuToolbar');
  var uiState = require('logic/Izenda.UiState');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var config = require('config');

  var connect = require('share/enhancers/Izenda.Connect');
  var BrowserUtils = require('share/utils/Izenda.BrowserUtils');

  const { isNil, get } = require('lodash/fp');

  /**
   * Tab Container Component
   */
  var Tabs = React.createClass({
    propTypes: {
      activeTabKey: React.PropTypes.string,
      onChange: React.PropTypes.func,
      canChangeTab: React.PropTypes.func,
      beforeChangeTab: React.PropTypes.func,
      isResponsive: React.PropTypes.bool,
      children: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.element]).isRequired,
      navigationClass: React.PropTypes.string,
      isOnPopover: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        activeTabKey: '',
        isResponsive: false
      };
    },
    getInitialState: function() {
      return {
        activeTabKey: this.props.activeTabKey || this.getDefaultTabKey()
      };
    },

    getDefaultTabKey: function() {
      if (this.props.children.length > 0) {
        var firstTabKey = this.props.children[0].props.tabKey;
        return firstTabKey;
      }
    },

    componentWillReceiveProps: function(newProps) {
      if (newProps.activeTabKey && newProps.activeTabKey !== this.state.activeTabKey) {
        this.setState({
          activeTabKey: newProps.activeTabKey
        });
      }
    },

    render: function() {
      var className = classnames('tabs', this.props.className);
      return (
        <div className={className}>
          {this.getMenuItems()}
          {this.getSelectedPanel()}
        </div>
      );
    },

    openHref: function(href) {
      this.props
        .confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm })
        .bind(this)
        .then(function() {
          this.props.router.push(href);
        });
    },

    setActive: function(index, e) {
      e && e.preventDefault();

      var props = this.props;
      var onChange = this.props.onChange;
      var canChangeTab = this.props.canChangeTab;
      var $selectedPanel = this.refs['tab-panel'];
      var $selectedTabMenu = this.refs['tab-menu-' + index];
      var activeTabKey = this.props.children[index - 1].props.tabKey;

      if (this.props.children[index - 1].props.isDisabled) {
        return;
      }

      var setTab = function() {
        if (activeTabKey === this.state.activeTabKey) {
          return;
        }

        props.beforeChangeTab && props.beforeChangeTab(activeTabKey);

        this.setState(
          {
            activeTabKey: activeTabKey
          },
          function() {
            if (onChange) {
              onChange(index, $selectedPanel, $selectedTabMenu, activeTabKey);
            }
          }
        );
      }.bind(this);

      if (canChangeTab) {
        canChangeTab(index, $selectedPanel, $selectedTabMenu, activeTabKey).then(function(result) {
          if (result) {
            setTab();
          }
        });
      } else {
        setTab();
      }
    },

    getMenuItems: function() {
      var navigationClasses = classnames('nav', 'nav-tabs', 'tabs-navigation', this.props.navigationClass);

      // Convert to list for children before render
      if (!Array.isArray(this.props.children)) {
        this.props.children = [this.props.children];
      }

      var menuItems = this.props.children
        .map(function(panel) {
          return typeof panel === 'function' ? panel() : panel;
        })
        .filter(function(panel) {
          return panel;
        })
        .map(
          function(panel, index) {
            const refIndex = index + 1;
            const ref = 'tab-menu-' + refIndex;
            const title = panel.props.title;
            const tabKey = panel.props.tabKey;
            const href = panel.props.href;
            const classes = classnames(panel.props.headerClassName, {
              active: this.state.activeTabKey === panel.props.tabKey,
              'tabs-menu-item': !this.props.isResponsive
            });
            const popoverOnIE = this.props.isOnPopover && BrowserUtils.isIEBrowser();

            // Fix issue IE not fire event onClick on popover
            const setActiveClickHandler = () => this.setActive(refIndex);
            const onClickText = popoverOnIE
              ? { onMouseDown: setActiveClickHandler }
              : { onClick: setActiveClickHandler };

            const openHrefClickHandler = e => {
              if (e.button === 0)
                e.preventDefault();
              this.openHref(href);
            };
            const onClickHref = popoverOnIE
              ? { onMouseDown: openHrefClickHandler }
              : { onClick: openHrefClickHandler};

            var routeLink = href;
            if (!isNil(routeLink) && config.Integration) {
              routeLink = routeUtils.getPathForIntegration(routeLink);
            }

            return (
              <li role="presentation" ref={ref} key={tabKey} className={classes}>
                {isNil(routeLink)
                  ? <a {...onClickText}>{title}</a>
                  : <a href={routeLink} {...onClickHref}>{title}</a>}
              </li>
            );
          }.bind(this)
        );

      return this.props.isResponsive ? (
        <MenuToolbar menuItems={menuItems} />
      ) : (
        <ul className={navigationClasses}>{menuItems}</ul>
      );
    },

    getSelectedPanel: function() {
      var props = this.props;
      var panel = props.children.filter(
        function(panel) {
          return get('props.tabKey', panel) === this.state.activeTabKey;
        }.bind(this)
      );

      var classes = classnames('tab-panel', props.panelClassName);

      return (
        <div ref="tab-panel" className={classes}>
          {panel}
        </div>
      );
    }
  });

  /**
   * Tab Component
   */
  var Tab = React.createClass({
    propTypes: {
      title: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]).isRequired,
      tabKey: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
      children: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.element]).isRequired,
      href: React.PropTypes.string
    },
    render: function() {
      return <div className={this.props.className}>{this.props.children}</div>;
    }
  });

  module.exports = { Tabs: connect({ toClass: true })(Tabs), Tab: Tab };
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Tab.jsx